import { useEffect, useState } from "react";
import { Button, Checkbox } from "@mui/material";

import { projectColumns } from "./grid-columns";
import { useSaveData } from "../../../../hooks/useSaveData";
import { useLoadData } from "../../../../hooks/useLoadData";
import { ApiResponse } from "../../../../models/api-response";
import { contactApiKeyStore } from "../../../../api/contact-api-key-store";
import { UserPermissionName } from "../../../../models/user-permission-name";
import { SiTrackGrid } from "../../../../components/si-track-grid/si-track-grid";
import { useAuthorize } from "../../../../hooks/use-authorize";
import { useSnackbar } from "../../../../hooks/use-snackbar.hook";

interface CellProps {
    moduleData: any;
}

interface CustomGridCellProps {
    field: string;
}

interface ProjectDuxComponent {
    contactID: any;
    onClosed: () => void;
}

export const ProjectDuxComponent = ({ contactID, onClosed }: ProjectDuxComponent) => {

    const { showSnackbar } = useSnackbar();
    const [originalData, SetOriginalData] = useState<any[]>([]);
    const [updatedProjectData, setProjectData] = useState<any[]>();
    const [changedProjectData, setChangedProject] = useState<any[]>([]);

    const { data, isLoading, isFetching } = useLoadData<ApiResponse<any[]>>(contactApiKeyStore.getDuxProjects(contactID));

    const { isLoading: isMapDuxLoading, mutateAsync } = useSaveData(contactApiKeyStore.addContactSyncWithDuxForProjects(),
        () => contactApiKeyStore.getContacts());

    useEffect(() => {
        if (data) {
            const updatedData = data?.data?.map((pl: any) => ({
                ...pl,
                isSelected: pl?.contactLevelSyncWithDux,
            }));
            setProjectData(updatedData);
            SetOriginalData(updatedData);
            // setChangedProject(updatedData?.filter((pla: any) => pla?.isSelected == true) ?? [])
        }
    }, [data]);

    const getChangedProjects = (originalData: any, updatedData: any) => {
        return updatedData
            .filter((updatedItem: any) => {
                // find matching object in originalData
                const originalItem = originalData.find((o: any) => o.projectID === updatedItem.projectID);

                // original doesn't have isSelected, so treat as false
                const originalSelected = originalItem?.isSelected ?? false;

                return updatedItem.isSelected !== originalSelected;
            })
            .map((item: any) => ({
                projectID: item.projectID,
                syncWithDux: item.isSelected
            }));
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>, moduleData: any) => {
        if (event.target.checked)
            if (moduleData?.contacts_CellPhone == "" || moduleData?.contacts_CellPhone == null) {
                showSnackbar('Cell phone number is required to enable Sync with Dux for this contact.', 'error');
                return;
            }
        const updatedData = updatedProjectData?.map((d: any) => ({
            ...d,
            isSelected: (moduleData?.projectID == d?.projectID) ? event.target.checked : d?.isSelected,
        }));
        setProjectData(updatedData);
        const changes = getChangedProjects(originalData, updatedData);
        setChangedProject(changes ?? [])
    };

    const SelectProjectCell = ({ moduleData }: CellProps) => {

        return (
            <td>
                <Checkbox
                    checked={updatedProjectData?.find((pl: any) => (pl.projectID == moduleData?.projectID))?.isSelected}
                    onChange={(e) => handleChange(e, moduleData)}
                    inputProps={{ 'aria-label': 'controlled' }}
                />
            </td>
        );
    };

    const CustomGridCell = ({ field }: CustomGridCellProps) => {
        if (field === 'contactLevelSyncWithDux') {
            return (dataItem: any) => {
                return <SelectProjectCell moduleData={dataItem.dataItem} />;
            };
        }
    }

    const handleSubmit = async () => {
        const duxData = {
            contactID: contactID,
            projects: changedProjectData
        }
        await mutateAsync({ data: duxData });
        onClosed();
    }

    const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

    return (
        <>
            <SiTrackGrid
                fileTitle='project_dux'
                columns={projectColumns}
                dataItemKey="projectID"
                dataItems={data?.data}
                customCell={(field) =>
                    CustomGridCell({
                        field,
                    })
                }
                actionPermissions={{
                    export: UserPermissionName.DOWNLOAD_GRID
                }}
                isBusy={isLoading || isFetching}
            />
            <div style={{ paddingTop: 15 }} className="spaceBetween">
                <Button variant="outlined" style={{ width: '130px' }} onClick={onClosed}>
                    Cancel
                </Button>
                <Button
                    type="button"
                    disabled={isLoading || isMapDuxLoading || isReadOnlyPermission || changedProjectData?.length == 0}
                    variant="contained"
                    style={{ width: '130px' }}
                    onClick={handleSubmit}
                >
                    Save
                </Button>
            </div>
        </>
    );
}